import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "../../../context/AuthContext";
import "./styles/DashboardLayout.css";

const NAV_ITEMS = [
  { to: "/dashboard/profile",  icon: <PersonIcon />,      label: "Profile"       },
  { to: "/dashboard/orders",   icon: <ReceiptLongIcon />, label: "Order History" },
  { to: "/dashboard/settings", icon: <SettingsIcon />,    label: "Settings"      },
];

const DashboardLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate("/"); };

  const initials = user?.name
    ? user.name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()
    : "U";

  return (
    <div className="dl-root">

      {/* ── MOBILE TOPBAR ── */}
      <div className="dl-mobile-bar">
        <button className="dl-hamburger" onClick={() => setSidebarOpen(true)}>
          <MenuIcon />
        </button>
        <span className="dl-mobile-title">My Account</span>
        <div style={{ width: 40 }} />
      </div>

      {/* ── OVERLAY ── */}
      {sidebarOpen && (
        <div className="dl-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── SIDEBAR ── */}
      <aside className={`dl-sidebar${sidebarOpen ? " dl-sidebar--open" : ""}`}>
        <button className="dl-sidebar-close" onClick={() => setSidebarOpen(false)}>
          <CloseIcon fontSize="small" />
        </button>

        {/* user chip */}
        <div className="dl-user-chip">
          <div className="dl-avatar">
            {user?.avatar
              ? <img src={user.avatar} alt={user.name} />
              : <span>{initials}</span>}
          </div>
          <div className="dl-user-info">
            <span className="dl-user-name">{user?.name}</span>
            <span className="dl-user-email">{user?.email}</span>
          </div>
        </div>

        <div className="dl-divider" />

        <nav className="dl-nav">
          {NAV_ITEMS.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `dl-nav-item${isActive ? " dl-nav-item--active" : ""}`
              }
              onClick={() => setSidebarOpen(false)}
            >
              <span className="dl-nav-icon">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="dl-divider" />

        <button className="dl-nav-item dl-logout" onClick={handleLogout}>
          <span className="dl-nav-icon"><LogoutIcon /></span>
          Logout
        </button>
      </aside>

      {/* ── MAIN CONTENT ── */}
      <main className="dl-content">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;